import React, { useContext, useEffect } from "react";
import { Button, Icon, Spacing, Title, toast } from "@sicredi/react";
import { TextBoletoAdesao } from "#/components/TextBoletoAdesao";
import styles from "./styles.module.scss";
import { useNavigate } from "react-router-dom";
import { ContextAPI } from "#/contextProver/ContextProver";
import {
  downloadFilePDF,
  formatValueMoney,
} from "#/contextProver/ContextProverServices";
import { PAGE } from "#/constants";

export const BoletoAdesao: React.FC = () => {
  const { vendaBoleto, isMobile } = useContext(ContextAPI);
  const navigate = useNavigate();
  const gobackNavigate = () => {
    navigate(-1);
  };

  const boleto = vendaBoleto ? vendaBoleto?.data : null;
  const code = boleto?.typeableLine;

  const copyClipBoard = () => {
    if (code) {
      navigator.clipboard.writeText(code);
      toast.warn("Código copiado");
      setTimeout(() => {
        toast.dismiss();
      }, 2000);
    }
  };

  useEffect(() => {
    if (boleto) {
      downloadFilePDF({
        base64DataFile: boleto.bill,
        nameFile: "boleto_Sicredi",
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (Object.keys(vendaBoleto).length === 0) {
      navigate(PAGE.ROOT);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={styles.container}>
      {isMobile && (
        <div className={styles.header}>
          <Icon name="arrow-left" onClick={gobackNavigate} />

          <Title as="h5">Consórcios</Title>
          <Spacing appearance="large" />
        </div>
      )}
      {boleto && (
        <Title as="h3">
          Boleto no valor <br /> de {formatValueMoney(boleto.billValue)}
        </Title>
      )}

      <TextBoletoAdesao
        title="Beneficiário"
        description={"Administradora de Consócio do Sicredi LTDA"}
      />
      <TextBoletoAdesao title="CNPJ" description={"078089070001/20"} />
      {boleto && (
        <TextBoletoAdesao title="Vencimento" description={boleto.dueDate} />
      )}
      {code && (
        <TextBoletoAdesao
          title="Para realizar o pagamento utilize o número de código de barras abaixo: "
          description={code}
        />
      )}
      <div className={styles.button_container}>
        {!isMobile && (
          <Button
            onClick={gobackNavigate}
            appearance="secondary"
            block={true}
            className={styles.button}
          >
            Voltar
          </Button>
        )}
        <Button
          onClick={copyClipBoard}
          appearance="primary"
          block={true}
          className={styles.button}
        >
          Copiar código
        </Button>
      </div>
    </div>
  );
};
